import React from 'react';
import styles from './InputHeader.module.scss';

interface InputHeaderProps {
  title: string;
}

export const InputHeader: React.FC<InputHeaderProps> = ({ title }) => {
  return <div className={styles.InputHeader}>{title.toUpperCase()}</div>;
};
